<template>
  <b-card class="card-job-garden-help mt-0 h-100" no-body :img-src="img_src" img-alt="Image" img-top>

    <!-- <img class="card-img-top" v-if="job.property.media != null && job.property.media.length > 0"
      :src="job.property.media[0].path" />
    <img class="card-img-top" v-else src="@/assets/images/garden-help/Logo.png"/> -->

    <template #header>
      <!-- <h4 class="mb-0">Hello World</h4> -->
      <b-row class="justify-content-center">
        <b-col xl="2" lg="3" md="2" cols="3" class="position-relative p-0"><img
            src="@/assets/images/garden-help/job-type-icon.png" />
        </b-col>
        <b-col xl="6" lg="6" md="6" cols="9" class="py-1 w-auto">
          <!-- <b-row :cols="job.contractor ? '2' : '1'"
            ><b-col class="p-1"> -->
          <b-card-sub-title>Type of work</b-card-sub-title>
          <b-card-title>{{ job.property.type }}</b-card-title>
          <!-- </b-col> -->
          <!-- <b-col class="p-1" v-if="job.contractor">
              <b-card-sub-title>Contractor</b-card-sub-title>
              <b-card-title>{{ job.contractor }}</b-card-title>
            </b-col> -->
          <!-- </b-row> -->
        </b-col>
      </b-row>
    </template>

    <span class="job-status" v-if="!job.operator">New</span>

    <b-card-body class="mt-2 py-0 ">
      <h5 class="list-title">Service Details</h5>
      <b-list-group class="servies-list">
        <b-list-group-item class="servies-list-item" v-for="(service, index) in job.orig_services" :key="index">
          <span class="check-span">
            <font-awesome-icon icon="fa-solid fa-circle-check" /></span>
          <p>{{ service.name }}</p>
        </b-list-group-item>
      </b-list-group>
    </b-card-body>

    <b-card-footer>
      <div>
        <b-row class="job-details-row my-1 mx-auto" v-if="job.property.size">
          <b-col>
            <b-form-group class="form-group-job-card" label="Property Size" label-for="property-size-val">
              <span id="property-size-val">{{ job.property.size }} {{ job.property.size_unit }}</span>
            </b-form-group>
          </b-col>
          <!-- <b-col>
            <b-form-group class="form-group-job-card float-right" label="Estimated Price" label-for="estimated-price-val">
              <span id="estimated-price-val" class="span-active">{{
                job.estimated_price
              }}</span>
            </b-form-group>
          </b-col> -->
        </b-row>
        <b-row class="job-details-row my-1 mx-auto" v-if="job.operator">
          <b-col>
            <b-form-group class="form-group-job-card" label="Contractor Name" label-for="contractor-val">
              <span id="contractor-val">{{ job.operator.name }}</span>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mx-auto" v-if="!job.operator"><b-col>
            <b-button type="button" variant="garden-help-primary"
              class="btn-bumblebee btn-garden-help mb-1 mx-auto w-100">Send Quote</b-button></b-col></b-row>
      </div>
    </b-card-footer>
  </b-card>
</template>

<script>
import $ from "jquery";
import moment from "moment";

export default {
  name: "JobCardJobsBoard",
  components: {},
  props: ["job"],
  data() {
    return {
      img_src: require('@/assets/images/garden-help/Logo.png')
    }
  },
  mounted() {
    this.img_src = this.job.property.media != null && this.job.property.media.length > 0 ? this.job.property.media[0].path : require('@/assets/images/garden-help/Logo.png')
  }
};
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/job_card/JobsBoard.vue